var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('va-edit-layout',{attrs:{"title":_vm.title}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('reading-competitions-form',{attrs:{"id":_vm.id,"title":_vm.title,"item":_vm.item}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }